module.exports = __webpack_public_path__ + "img/clic.6551d8b4.svg";